import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { Card, Button, Tabs, Icon } from 'antd';
import { connect, reducers } from 'kts-platform-frame/redux';
import ReduxState from 'kts-platform-frame/redux/ReduxState';
import TableList from './TableList';
import MyStore from 'kts-platform-frame/redux/MyStore';
import LogList from './LogList';
const css = require('./index.scss');
const TabPane = Tabs.TabPane;


/** Props接口 */
interface IProps extends IPropsBasic {

}
export default class UIComponents extends React.Component<IProps, any> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            key: this.props.location.pathname,
            fresh1: '',
            fresh2: '',
            addModal: false,
            count: null
        };
    }
    refreshCount = (value) => {
        this.setState({
            count: value
        });
    }
    callback = (key) => {
        this.setState({
            key
        });
        this.props.history.push(key);
    }
    componentWillReceiveProps(nextProps: any) {
        
    }
    render() {
        const { count, key } = this.state;

        return (
            <Card className={css['invoiceGroup']} bordered={false}>
                <Tabs defaultActiveKey={key} activeKey={key} onChange={this.callback} type="card">
                    <TabPane tab={<div><Icon type="bars" />发票列表{!!count && `(${count})`}</div>} key="/workbench/invoiceInput">
                        {
                            this.state.key === '/workbench/invoiceInput' && <TableList fresh={this.state.fresh1} refreshCount={this.refreshCount} />
                        }
                    </TabPane>
                    <TabPane tab={<div><Icon type="laptop" />录入记录</div>} key="/workbench/invoiceInput/log">
                        {
                            this.state.key === '/workbench/invoiceInput/log' && <LogList fresh={this.state.fresh2} />
                        }
                    </TabPane>
                </Tabs>
            </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/InvoiceInput/UI.Components.tsx